import { createHook, createStore, StoreActionApi } from "react-sweet-state"
import { LoadingStateDefaults } from "components/state/loadingstate"
import { load } from "components/state/loader"
import { Container, Dictionary, toDictionary } from "components/state/types"
import { EndpointResponse } from "components/http/endpoint"
import { NoEntityError, updateByResponse } from "components/validation/validatableentity"
import { EntityState } from "components/state/entity"
import { load as loadCountriesEndpoint } from "./endpoint"
import { Countries, CountriesDefaults } from "./entity"

interface State extends EntityState<Countries> {
    countries_dict: Dictionary<string>
}

const StateDefaults: State = {
    ...LoadingStateDefaults,
    entity: CountriesDefaults,
    errors: { ...NoEntityError },
    countries_dict: {}
}

const loadCountries = () =>
    (store: StoreActionApi<State>) => {

        let loader = () => loadCountriesEndpoint();

        let stateProducer =
            (draft: State, _: Container, response: EndpointResponse): void => {
                updateByResponse(draft, response);
                draft.countries_dict = toDictionary(draft.entity, c => c.code, c => c.name);
            }

        load<State>(store, loader, stateProducer);
    };

const store = createStore({
    initialState: StateDefaults,
    actions: {
        loadCountries,
    },
    name: "Countries"
});

const useState = createHook(store);

export {
    StateDefaults as CountriestateDefaults,
    State as CountriesState,
    useState as useCountries,
}
